'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dAbstract$002dSet from "./java.util.-Abstract-Set.js";
import * as $j_java$002eutil$002e$002dHash$002dMap$0024$002dNode$002dIterator from "./java.util.-Hash-Map$-Node-Iterator.js";
import * as $j_java$002eutil$002e$002dMap$0024$002dEntry from "./java.util.-Map$-Entry.js";
var $p;
/** @constructor */
function $c_ju_HashMap$EntrySet(outer) {
  this.m2 = null;
  this.m2 = outer;
}
export { $c_ju_HashMap$EntrySet as $c_ju_HashMap$EntrySet };
$p = $c_ju_HashMap$EntrySet.prototype = new $j_java$002eutil$002e$002dAbstract$002dSet.$h_ju_AbstractSet();
$p.constructor = $c_ju_HashMap$EntrySet;
/** @constructor */
function $h_ju_HashMap$EntrySet() {
}
export { $h_ju_HashMap$EntrySet as $h_ju_HashMap$EntrySet };
$h_ju_HashMap$EntrySet.prototype = $p;
$p.cV = (function() {
  return new $j_java$002eutil$002e$002dHash$002dMap$0024$002dNode$002dIterator.$c_ju_HashMap$NodeIterator(this.m2);
});
$p.T = (function() {
  return this.m2.ga;
});
$p.ae = (function(o) {
  if ($j_java$002eutil$002e$002dMap$0024$002dEntry.$is_ju_Map$Entry(o)) {
    var this$1 = this.m2;
    var key = o.ek;
    if ((key === null)) {
      var hash = 0;
    } else {
      var originalHash = $j_java$002elang$002e$002dObject.$dp_hashCode__I(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    }
    var node = this$1.ue(key, hash, (hash & ((this$1.dm.a.length - 1) | 0)));
    if ((node !== null)) {
      var a = node.dn;
      var b = o.dn;
      return ((a === null) ? (b === null) : $j_java$002elang$002e$002dObject.$dp_equals__O__Z(a, b));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.la = (function(o) {
  if ($j_java$002eutil$002e$002dMap$0024$002dEntry.$is_ju_Map$Entry(o)) {
    var key = o.ek;
    var this$1 = this.m2;
    if ((key === null)) {
      var hash = 0;
    } else {
      var originalHash = $j_java$002elang$002e$002dObject.$dp_hashCode__I(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    }
    var idx = (hash & ((this$1.dm.a.length - 1) | 0));
    var node = this$1.ue(key, hash, idx);
    if ((node !== null)) {
      var a = node.dn;
      var b = o.dn;
      var $x_1 = ((a === null) ? (b === null) : $j_java$002elang$002e$002dObject.$dp_equals__O__Z(a, b));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this.m2.BV(node, idx);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
var $d_ju_HashMap$EntrySet = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_HashMap$EntrySet, "java.util.HashMap$EntrySet", ({
  n4: 1,
  cg: 1,
  bt: 1,
  aU: 1,
  bc: 1,
  cl: 1
}));
export { $d_ju_HashMap$EntrySet as $d_ju_HashMap$EntrySet };
